import React from 'react';
import { aboutTrine } from '../data';
import { ShieldCheck } from 'lucide-react';
import { motion } from 'framer-motion';

const About = () => {
  return (
    <section id="om-trine" className="pt-16 pb-24 md:pt-24 md:pb-32 bg-orange-50/40 overflow-hidden relative">
      {/* Decorative background element */}
      <div className="absolute top-0 right-0 w-1/3 h-full bg-stone-200/20 -z-0"></div>
      
      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="flex flex-col-reverse lg:flex-row items-center gap-16 lg:gap-24">
          
          {/* Content Side */}
          <motion.div 
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.8 }}
            className="w-full lg:w-3/5"
          >
            <div className="max-w-2xl">
              <span className="text-xs uppercase tracking-[0.2em] text-stone-400 mb-4 block">
                Mød din behandler
              </span>
              <h2 className="text-4xl md:text-5xl lg:text-6xl font-light text-stone-900 mb-10 leading-tight">
                {aboutTrine.name}
                <span className="block text-2xl md:text-3xl text-stone-500 mt-4 font-serif italic tracking-wide">
                  {aboutTrine.title}
                </span>
              </h2>
              
              <div className="space-y-6 text-stone-600 font-light leading-relaxed text-lg">
                <div className="whitespace-pre-line text-stone-700 leading-relaxed">
                  {aboutTrine.bio}
                </div>
              </div>

              {/* RAB Section */}
              <motion.div 
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.3 }}
                className="mt-16 p-10 bg-stone-50 shadow-sm border-l-4 border-stone-800"
              >
                <div className="flex items-start space-x-4">
                  <div className="bg-stone-800 p-2 rounded-full mt-1">
                    <ShieldCheck size={20} className="text-stone-50" />
                  </div>
                  <div>
                    <h3 className="text-sm uppercase tracking-widest font-semibold text-stone-900 mb-3">
                      Hvad betyder RAB-registreret?
                    </h3>
                    <p className="text-sm text-stone-600 leading-relaxed font-light">
                      {aboutTrine.rabExplanation}
                    </p>
                  </div>
                </div>
              </motion.div>
            </div>
          </motion.div>

          {/* Image Side */}
          <motion.div 
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 1 }}
            className="w-full md:w-2/3 md:mx-auto lg:w-2/5"
          >
            <div className="relative">
              <div className="aspect-[3/4] overflow-hidden">
                <img
                  src={aboutTrine.image}
                  alt="Trine Agerbo"
                  className="w-full h-full object-cover grayscale-[10%]"
                />
              </div>
              
              {/* Floating Badge */}
              <motion.div 
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0.5 }}
                className="absolute -bottom-10 left-1/2 -translate-x-1/2 bg-white px-8 py-6 shadow-xl border border-stone-100 hidden sm:block w-max"
              >
                <div className="flex flex-col items-center">
                  <span className="text-[10px] uppercase tracking-[0.3em] text-stone-400 mb-1">Erfaren</span>
                  <span className="text-xl font-light text-stone-800">Massageterapeut</span>
                </div>
              </motion.div>
            </div>
          </motion.div>

        </div>
      </div>
    </section>
  );
};

export default About;
